export enum TimeoffApprovalStatusEnum {
    APPROVED = "APPROVED",
    PENDING = "PENDING",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}

export enum TimeOffAccrualPeriodEnum {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY",
    ON_ANNIVERSARY = "ON_ANNIVERSARY",
}

export enum TimeoffAccrualWaitingPeriod { 
    DAYS = "DAYS",
    MONTHS = "MONTHS",
    YEARS = "YEARS",
}

export enum TimeoffCarryOverRule {
    UPTO = "UPTO",
    UNLIMITED = "UNLIMITED",
}

export enum TimeoffPolicyTypeEnum { 
    accrues_time = "accrues_time",
    flexible = "flexible",
}